//  Versão atual do sistema (ALTERADA PARA GERAR BADGE)
export const SYSTEM_VERSION = "v1.5.0";

export const CHANGELOG = [
  // NOVA VERSÃO — vai gerar badge automática
  {
    versao: "v1.7.2",
    data: "28/02/2026",
    perfis: ["ADMIN", "DRS", "MUNICIPIO", "USUARIO"],
    tipo: "MELHORIA",
    titulo: "Teste 2",
    itens: [
      "Otimização de carregamento do dashboard.",
      "Ajustes visuais institucionais.",
      "Correções internas de performance.",
      "Aprimoramento na navegação lateral.",
    ],
  },

  {
    versao: "v1.7.0",
    data: "28/02/2026",
    perfis: ["ADMIN", "DRS", "MUNICIPIO", "USUARIO"],
    tipo: "MELHORIA",
    titulo: "Teste 2",
    itens: [
      "Otimização de carregamento do dashboard.",
      "Ajustes visuais institucionais.",
      "Correções internas de performance.",
      "Aprimoramento na navegação lateral.",
    ],
  },

  {
    versao: "v1.6.0",
    data: "28/02/2026",
    perfis: ["ADMIN", "DRS", "MUNICIPIO", "USUARIO"],
    tipo: "MELHORIA",
    titulo: "Teste",
    itens: [
      "Otimização de carregamento do dashboard.",
      "Ajustes visuais institucionais.",
      "Correções internas de performance.",
      "Aprimoramento na navegação lateral.",
    ],
  },

  {
    versao: "v1.5.0",
    data: "28/02/2026",
    perfis: ["ADMIN", "DRS", "MUNICIPIO", "USUARIO"],
    tipo: "MELHORIA",
    titulo: "Melhorias Gerais de Estabilidade",
    itens: [
      "Otimização de carregamento do dashboard.",
      "Ajustes visuais institucionais.",
      "Correções internas de performance.",
      "Aprimoramento na navegação lateral.",
    ],
  },

  {
    versao: "v1.4.0",
    data: "28/02/2026",
    perfis: ["ADMIN", "DRS", "MUNICIPIO", "USUARIO"],
    tipo: "MELHORIA",
    titulo: "Sistema de Atualizações (Changelog)",
    itens: [
      "Implementação da página oficial de Atualizações.",
      "Notificação automática de nova versão no menu lateral.",
      "Controle de leitura por usuário.",
      "Exibição de versão atual no rodapé do sistema.",
    ],
  },

  {
    versao: "v1.3.0",
    data: "24/02/2026",
    perfis: ["ADMIN", "DRS", "MUNICIPIO"],
    tipo: "MELHORIA",
    titulo: "Nova Central de Chamados",
    itens: [
      "Reorganização visual da listagem de chamados.",
      "Padronização institucional das cores de status.",
      "Melhoria na visualização de anexos.",
    ],
  },

  {
    versao: "v1.2.0",
    data: "20/02/2026",
    perfis: ["ADMIN", "DRS"],
    tipo: "CORREÇÃO",
    titulo: "Ajustes no Perfil DRS",
    itens: [
      "Correção na seleção de estabelecimentos.",
      "Inclusão da opção 'TODOS' para DRS.",
      "Correção de inconsistência após refresh.",
    ],
  },

  {
    versao: "v1.1.0",
    data: "15/02/2026",
    perfis: ["ADMIN"],
    tipo: "NOVO RECURSO",
    titulo: "Controle de Acesso por Perfil",
    itens: [
      "Implementação de restrição de menus por tipo de usuário.",
      "Validação de acesso no frontend.",
    ],
  },

  {
    versao: "v1.0.0",
    data: "01/02/2026",
    perfis: ["ADMIN", "DRS", "MUNICIPIO", "USUARIO"],
    tipo: "LANÇAMENTO",
    titulo: "Lançamento Oficial do Sistema",
    itens: [
      "Implementação do Dashboard de Rastreamento.",
      "Filtros avançados por idade e período.",
      "Integração com API de rastreamento.",
    ],
  },
];
